import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { crd, bdg } from "../../constants/styles";
import MC from "../common/MC";

function SpDash({ sp }) {
  const { t, h, go, setSelMaintId, sps, currUserId } = useContext(Ctx);
  if (sp.loading) return <div style={{ paddingTop: 40, textAlign: "center" }}><div style={{ color: h.sc, fontSize: 13 }}>{t.syncingDb}</div></div>;
  const spJobs = sp.data?.jobs || []; const spPayments = sp.data?.payments || []; const spProfile = sp.data?.profile;
  const spTens = sp.data?.tens || []; const spProps = sp.data?.props || [];

  const pending = spJobs.filter(j => j.sp_status === 'pending' || j.sp_status === 'accepted').length;
  const inProg = spJobs.filter(j => j.sp_status === 'in_progress').length;
  const completed = spJobs.filter(j => j.sp_status === 'completed' || j.confirmed_by_tenant).length;
  const totalEarned = spPayments.filter(p => p.st === 'paid').reduce((s, p) => s + (p.amount || 0), 0);
  const pendingPay = spPayments.filter(p => p.st === 'pending').reduce((s, p) => s + (p.amount || 0), 0);
  const recentJobs = spJobs.filter(j => j.sp_status !== 'completed' && !j.confirmed_by_tenant).slice(0, 3);

  // Check location from both sync data AND sps context (updated immediately after profile save)
  const spFromCtx = (sps || []).find(s => s.id === currUserId);
  const hasLocation = spProfile?.latitude || spProfile?.lat || spFromCtx?.latitude || spFromCtx?.lat;

  return <div style={{ paddingTop: 16 }}>
    <h2 style={{ color: h.tx, fontSize: 20, fontWeight: 700, margin: "0 0 4px" }}>{t.welcome}{spProfile?.name ? `, ${spProfile.name}` : ""}!</h2>
    <p style={{ color: h.sc, fontSize: 12, margin: "0 0 16px" }}>{spProfile?.skill || ""}</p>

    {/* Location prompt if not set */}
    {!hasLocation && <div onClick={() => go("profile")} style={{ display: "flex", alignItems: "center", gap: 10, background: `${h.wn}10`, border: `1px solid ${h.wn}25`, borderRadius: 12, padding: "12px 14px", marginBottom: 16, cursor: "pointer" }}>
      <span style={{ fontSize: 20 }}>{"\uD83D\uDCCD"}</span>
      <div style={{ flex: 1 }}>
        <div style={{ color: h.wn, fontWeight: 600, fontSize: 12 }}>Pin your shop location</div>
        <div style={{ color: h.sc, fontSize: 11, marginTop: 2 }}>Required to receive nearby job assignments</div>
      </div>
      <span style={{ color: h.wn, fontSize: 14, fontWeight: 700 }}>{"\u2192"}</span>
    </div>}
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 16 }}>
      <MC ic="wrench" l={t.totalAssigned} v={spJobs.length} cl={h.ac} h={h} onClick={() => go("spJobs")} />
      <MC ic="zap" l={t.pendingJobs} v={pending} cl={h.wn} h={h} onClick={() => go("spJobs")} />
      <MC ic="gear" l={t.inProgressJobs} v={inProg} cl={h.pp} h={h} onClick={() => go("spJobs")} />
    </div>
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 20 }}>
      <MC ic="shield" l={t.completedJobs} v={completed} cl={h.gn} h={h} onClick={() => go("spHistory")} />
      <MC ic="dollar" l={t.totalEarnings} v={`₹${totalEarned.toLocaleString()}`} cl={h.gn} h={h} onClick={() => go("spEarnings")} />
      <MC ic="dollar" l={t.pendingPay} v={`₹${pendingPay.toLocaleString()}`} cl={h.wn} h={h} onClick={() => go("spEarnings")} />
    </div>
    {recentJobs.length > 0 && <><div style={{ color: h.tx, fontWeight: 700, fontSize: 15, marginBottom: 10 }}>{t.recentJobs}</div>
    {recentJobs.map(j => { const ten = spTens.find(x => x.id === j.tid); const prop = spProps.find(x => x.id === ten?.pid);
      return <div key={j.id} onClick={() => { setSelMaintId(j.id); go("spJobDetail"); }} style={{ ...crd(h), cursor: "pointer" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
          <div><div style={{ color: h.tx, fontWeight: 600, fontSize: 13 }}>{j.desc}</div><div style={{ color: h.sc, fontSize: 11 }}>{ten?.name || "?"} {prop ? `· ${prop.addr}` : ""}</div></div>
          <span style={bdg(j.sp_status === 'pending' ? `${h.wn}20` : j.sp_status === 'in_progress' ? `${h.pp}20` : `${h.gn}20`, j.sp_status === 'pending' ? h.wn : j.sp_status === 'in_progress' ? h.pp : h.gn)}>{j.sp_status === 'pending' ? t.pendingJobs : j.sp_status === 'accepted' ? t.accepted : j.sp_status === 'in_progress' ? t.inProgress : t.completed}</span>
        </div>
      </div>; })}</>}
  </div>;
}

export default SpDash;
